import { render, staticRenderFns } from "./NI.vue?vue&type=template&id=9dfdbf8e&scoped=true&"
import script from "./NI.vue?vue&type=script&lang=js&"
export * from "./NI.vue?vue&type=script&lang=js&"
import style0 from "./NI.vue?vue&type=style&index=0&id=9dfdbf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfdbf8e",
  null
  
)

export default component.exports